import { AnnouncementsCard } from '@backstage-community/plugin-announcements';
import type { CreateCardHomePageWidget } from './Home';

const AnnouncementsWidget = () => (
  <AnnouncementsCard
    title="Announcements"
    max={3}
    active
    current
    sortBy="start_at"
    order="desc"
  />
);

export const createAnnouncementsWidget = (
  createCardHomePageWidget: CreateCardHomePageWidget,
) =>
  createCardHomePageWidget({
    extensionId: 'announcements',
    widgetName: 'Announcements',
    title: 'Announcements',
    description: 'Latest announcements from your team',
    Component: AnnouncementsWidget,
  });
